import * as React from "react";
import { Box, Paper, Typography, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { Message } from "./types";

interface ChatUserMessageProps {
  message: Message;
  onEdit?: () => void;
}

export const ChatUserMessage: React.FC<ChatUserMessageProps> = ({
  message,
  onEdit,
}) => {
  const [showEdit, setShowEdit] = React.useState(false);

  return (
    <Box
      position="relative"
      sx={{
        display: "flex",
        justifyContent: "flex-end",
      }}
      onMouseEnter={() => setShowEdit(true)}
      onMouseLeave={() => setShowEdit(false)}
    >
      <Paper
        sx={{
          position: "relative",
          py: 1,
          px: 2,
          maxWidth: "60%",
          bgcolor: (theme) => theme.palette.grey[200],
          boxShadow: "none",
          borderRadius: 4,
        }}
      >
        <Typography variant="body1">{message.content}</Typography>
      </Paper>
      {onEdit && (
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            bottom: -28,
            right: 0,
            color: (theme) => theme.palette.grey[600],
            opacity: showEdit ? 1 : 0,
          }}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
          aria-label="Modifica messaggio"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
